import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import MdvPanel from "../components/MdvPanel/MdvPanel";
import "./MdvPage.css";

export default function MdvPage() {
  const navigate = useNavigate();
  const { mdvObject, hashtag_id } = useApp();

  if (!mdvObject) {
    return (
      <div className="mdv-page">
        <div className="mdv-empty">
          <h3>Sin datos MDV</h3>
          <p>Genera un Super Prompt en Prompt IN para ver el Marco de Dimensiones Visuales.</p>
          <button className="mdv-btn-go" onClick={() => navigate("/keyframes/prompt-in")}>
            → Ir a Prompt IN
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mdv-page">
      <MdvPanel
        mdv={mdvObject}
        hashtag_id={hashtag_id}
        open={true}
        onToggle={() => {}}
        fullscreen
      />
    </div>
  );
}
